import {
  Component,
  Input,
  ViewChild,
  OnInit,
  HostListener,
  TemplateRef,
  Inject
} from '@angular/core';
import { NotificationService } from '../../services/notification.service';
import { Router, ActivationStart, ActivatedRoute, NavigationEnd, Data } from '@angular/router';
import { UserNotification } from '../../models/user-notification';
import { Client, ClientSetup } from '../../models/client';
import { CompaniesService } from '../../services/companies.service';
import { forkJoin, Observable, Subject } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { Pagination } from '../../models/pagination';
import { NgbDropdown, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuditService } from '../../services/audit.service';
import { LogLevels } from '../../models/audit-action';
import { ModalService } from '../../services/modal.service';
import { AppConfigService } from '../../services/app-config.service';
import { KnowledgeBaseService } from '../../services/knowledge-base.service';
import { concatMap, first, map, mergeMap, take, tap } from 'rxjs/operators';
import { Article } from '../../models/knowledge-base';
import { InstanceTypes, PortalInfo } from '../../models/instance-types';
import { PayrollManagement } from '../../tools/payroll-management';
import { AclService } from '../../services/acl.service';
import { SwipeclockService } from '../../services/swipeclock.service';
import { ClientNotesModalComponent } from '../client-notes-modal/client-notes-modal.component';
import { Select, Store } from '@ngxs/store';
import { Navigate } from '@ngxs/router-plugin';
import {
  ClearClientState,
  ClientSelectionState
} from '../../state/ClientSelectionState/ClientSelection.state';
import { EmployerSelectionState } from '../../state/EmployerSelectionState/EmployerSelection.state';

@Component({
  selector: 'lib-nav-header',
  templateUrl: './nav-header.component.html',
  styleUrls: ['./nav-header.component.scss'],
  standalone: false
})
export class NavHeaderComponent implements OnInit {
  @Input() showCSRHome = false;
  @ViewChild('notifyDropDown') notifyDropDown: NgbDropdown;
  @ViewChild('releaseNotesTemplate', { static: false })
  public releaseNotesTemplate: TemplateRef<any>;

  public activeNotification: UserNotification = null;
  public auth: AuthService;
  @Select(ClientSelectionState.clientCode)
  public clientCode: Observable<string>;
  public collapseNotifications = true;
  public enableReleaseNotes = false;
  public instanceWatermark = '';
  public isMenuCollapsed = true;
  public loggedIn = false;
  public validRoles = false;
  public notificationCount: number;
  public notifications: UserNotification[];
  public notificationViewMode = false;
  public notifyPagination: Pagination;
  public releaseNotes: Article[];
  @Select(ClientSelectionState.client)
  public selClient: Observable<Client>;
  public unreadArticleIds: number[] = [];
  public userName: string = '';
  public viewDelNotifications = false;
  // watermark
  public wmIter = Array.apply(null, Array(200)).map(function (x, i) {
    return i;
  });
  //These are needed for the collapsed client subnav
  public payrollRoute: Subject<string> = new Subject<string>();
  public baseUrl: string;
  public canViewReports = false;
  public canEditPeople = false;
  public canDoPayroll = false;
  public route;
  public activeTab;
  public renderSubnav = false;
  @Select(ClientSelectionState.clientSetup)
  clientSetup: Observable<ClientSetup>;
  swipeclockJWTSucceeded: boolean = false;

  switchPortalInfo: PortalInfo[] = [];

  public get isClientPortal() {
    return this.env.instanceType == InstanceTypes.ClientPortal;
  }
  public get isCSR() {
    return this.env.instanceType == InstanceTypes.CsrPortal;
  }
  get isEmployeePortal() {
    return this.env.instanceType === InstanceTypes.EmployeePortal;
  }
  get isLandingPortal() {
    return this.env.instanceType === InstanceTypes.LandingPortal;
  }

  get hasSwipeclockClientSetup() {
    return this.clientSetup.pipe(
      map(clientSetup => {
        return (
          clientSetup != null &&
          clientSetup.TimeclockVendorId == 'SC' &&
          (clientSetup.AllowTimeclockPunch ||
            clientSetup.AllowTimeclockPTO ||
            clientSetup.AllowTimeclockSchedule)
        );
      })
    );
  }

  get hasSwipeclockAccess() {
    return this.hasSwipeclockClientSetup.pipe(
      map(result => {
        return result && this.swipeclockJWTSucceeded;
      })
    );
  }

  @HostListener('window:refreshUserNotifications', ['$event,target'])
  onNotificationRefresh() {
    this.notifyPagination.Page = 1;
    this.loadNotifications(this.notifyPagination);
  }

  constructor(
    private appConfigService: AppConfigService,
    private auditService: AuditService,
    public authService: AuthService,
    private companyService: CompaniesService,
    private kbService: KnowledgeBaseService,
    private modalService: ModalService,
    public notificationService: NotificationService,
    public router: Router,
    private payrollMgmt: PayrollManagement,
    private aclService: AclService,
    private ngModalService: NgbModal,
    private swipeclockSvc: SwipeclockService,
    private store: Store,
    @Inject('env') private env: any,
    @Inject('authCodeFlowConfig') private authCodeFlowConfig: any
  ) {
    this.auth = authService;
  }

  ngOnInit() {
    this.notifyPagination = new Pagination();
    this.notifyPagination.Page = 1;
    this.notifyPagination.PerPage = 10;

    this._setClientNameOnRouteChange();

    this.authService.isLoggedIn().subscribe(resp => {
      if (resp) {
        this._init();
      } else {
        this.authService.isLoginComplete$.subscribe(val => {
          if (val) {
            this._init();
          }
        });
      }
    });
    this.authService.userLoginStatus.subscribe(result => {
      this.loggedIn = result;
      this.validRoles = this.authService.isInAllowedRole();
    });
  }

  // #region public methods

  public checkNotifyMode() {
    // if user was previously viewing dismissed notifications
    // refetch active list when notification panel is opened next
    if (this.viewDelNotifications) {
      this.viewActiveNotifications();
    }
  }

  public clearAlert() {
    this.notificationService.dismiss(this.activeNotification.Id).subscribe(() => {
      this.loadNotifications(this.notifyPagination);
      this.viewNotificationList();
    });
  }

  public clearAllAlerts() {
    const user = this.authService.getCurrentUserName();
    this.notificationService.dismissAll(user).subscribe(() => {
      this.loadNotifications(this.notifyPagination);
    });
  }
  public csrHomeClicked() {
    this.store.dispatch(new ClearClientState()).subscribe(_ => {
      this.isMenuCollapsed = true;
      this.store.dispatch(new Navigate(['/home']));
    });
  }
  public loadNotifications({ Page }: Pagination) {
    if (this.isLandingPortal) {
      return;
    }

    const user = this.authService.getCurrentUserName();
    this.notificationService
      .getUserNotifications(user, this.viewDelNotifications, Page, this.notifyPagination.PerPage)
      .subscribe(n => {
        this.notifications = n.Items;
        this.notifyPagination = n.Pagination;
        if (!this.viewDelNotifications) {
          this.notificationCount = n.Pagination.Total;
        }
      });
  }

  public logout() {
    if (this.env.logLevel <= LogLevels.Debug) {
      this.auditService
        .auditWithResponse('user-clicked-logout', {
          User: this.authService.getCurrentUserName()
        })
        .subscribe(
          () => {
            this.authService.signOut();
          },
          () => {
            this.authService.signOut();
          }
        );
    } else {
      this.authService.signOut();
    }
  }

  public navFocusOut(event) {
    // try to hook into event when user clicks off of the nav
    // in order to close the mobile menu. if clicked element is a child
    // of the nav, do not close.
    if (!event.currentTarget.contains(event.relatedTarget) && event.target.id != 'navNotifyClose') {
      this.isMenuCollapsed = true;
    }
  }

  public navigateToAccountManagement() {
    window.open(`${this.authCodeFlowConfig.issuer}/manage`, '_newtab');
  }

  public showReleaseNotes() {
    if (!this.releaseNotes || !this.releaseNotes.length) {
      return;
    }

    this.modalService.showFlyInModal("What's New In Relay", this.releaseNotesTemplate);

    // for and unread articles, mark them as read
    for (let article of this.releaseNotes) {
      if (this.unreadArticleIds.includes(article.Id)) {
        this.kbService.markArticleRead(article.Id).subscribe(() => {});
      }
    }

    // update the in memory collection of unread article ids
    this.unreadArticleIds = [];
  }

  public viewActiveNotifications() {
    this.viewDelNotifications = false;
    this.notifyPagination.Page = 1;
    this.loadNotifications(this.notifyPagination);
  }

  public viewDismissedNotifications() {
    this.viewDelNotifications = true;
    this.loadNotifications(this.notifyPagination);
  }

  public viewNotification(notification: UserNotification) {
    if (!notification.IsRead) {
      notification.IsRead = true;
      this.notificationService.markAsRead(notification.Id);
    }

    this.activeNotification = notification;
    this.notificationViewMode = true;
  }

  public viewNotificationList() {
    this.notificationViewMode = false;
    this.activeNotification = null;
  }

  public navigateToPortal(info: PortalInfo) {
    this.store.dispatch(new ClearClientState()).subscribe(() => {
      window.location.href = info.Url;
    });
  }

  // #endregion

  //#region private methods

  private _fetchReleaseNotes() {
    this.enableReleaseNotes = this.appConfigService.getConfig().EnableReleaseNotes;

    if (!this.enableReleaseNotes) {
      return;
    }

    // fetch release notes and generate count of unread
    const folderId = this.appConfigService.getConfig().KnowledgeBase.ReleaseNotesFolderId;

    this.kbService
      .getArticlesInFolder(folderId)
      .pipe(
        concatMap((articles: Article[]) => {
          return this.kbService.getArticlesReadByUser().pipe(
            map(count => {
              // for each article that is not in the count
              this.unreadArticleIds = articles.filter(x => !count?.includes(x.Id)).map(x => x.Id);
              this.releaseNotes = articles || [];
            })
          );
        })
      )
      .subscribe(() => {});
  }

  private _init() {
    this.notifyPagination.Page = 1;
    this.loadNotifications(this.notifyPagination);
    this.userName = `${this.authService.user.GivenName} ${this.authService.user.FamilyName}`;
    this.instanceWatermark = this.env.watermarkText;
    this._fetchReleaseNotes();
    this._setupExternalPortalLinks();
  }

  // when the route changes, check if it has a client_code param
  private _setClientNameOnRouteChange() {
    this.clientCode.subscribe(clientCode => {
      if (clientCode != null && clientCode != '') {
        this.canViewReports = false;
        this.canDoPayroll = false;
        this.canEditPeople = false;
        this.renderSubnav = false;
        this.payrollRoute.next('');

        this.initSubNav();
      }
    });
  }

  private initSubNav() {
    if (this.isClientPortal || this.isCSR) {
      this.baseUrl = this.env.instanceType === InstanceTypes.ClientPortal ? '' : '/client';
    } else if (this.isEmployeePortal) {
      this.baseUrl = this.env.instanceType === InstanceTypes.EmployeePortal ? '' : '/employee';
      if (this.isEmployeePortal) {
        const obs: Observable<any>[] = [
          this.store.selectOnce(ClientSelectionState.clientCode),
          this.store.selectOnce(EmployerSelectionState.personId),
          this.hasSwipeclockClientSetup.pipe(take(1))
        ];
        forkJoin(obs).subscribe(result => {
          if (result[2]) {
            this.swipeclockSvc
              .getPortalJwt('EmployeeSSO', result[0], result[1].toString())
              .subscribe(ret => {
                this.swipeclockJWTSucceeded = ret.success;
              });
          }
        });
      }
    }

    this.clientCode.subscribe(clientCode => {
      this.payrollRoute.next(`/client/${clientCode}/payroll-landing`);
    });

    if (this.env.instanceType === InstanceTypes.ClientPortal) {
      const userId = this.authService.user.UserId;
      this.clientCode
        .pipe(
          first(),
          mergeMap(clientCode => {
            return this.aclService.AccessCheck(
              userId,
              'Client Portal Admin',
              'Reports',
              clientCode
            );
          })
        )
        .subscribe(result => {
          this.canViewReports = result;
        });
      this.clientCode
        .pipe(
          first(),
          mergeMap(clientCode => {
            return this.aclService.AccessCheck(
              userId,
              'Client Portal Admin',
              'EditPeople',
              clientCode
            );
          })
        )
        .subscribe(result => {
          this.canEditPeople = result;
        });
      this.clientCode
        .pipe(
          first(),
          mergeMap(clientCode => {
            return this.aclService.AccessCheck(
              userId,
              'Client Portal Admin',
              'RunPayroll',
              clientCode
            );
          })
        )
        .subscribe(result => {
          this.canDoPayroll = result;
        });
    } else if (!this.isEmployeePortal) {
      this.canViewReports = true;
      this.canEditPeople = true;
      this.canDoPayroll = true;
    }

    this.renderSubnav = true;
  }

  private _setupExternalPortalLinks() {
    if (this.env.instanceType == InstanceTypes.LandingPortal) return;

    var config = this.appConfigService.getConfig();

    var allPortals = config.ExternalPortalInfo as PortalInfo[];

    if (allPortals == null) return;

    for (var info of allPortals) {
      if (this.env.instanceType != info.InstanceType && this.authService.isInAnyRole(info.Roles)) {
        this.switchPortalInfo.push(info);
      }
    }
  }

  //#endregion
}
